import BlurLinearOutlined from "@mui/icons-material/BlurLinearOutlined";
import { Calendar } from "../../../../../styles/icons/calendar";
import { makeDefaultFilters } from "../../../../../utils/default-filters";
import { useIsActive } from "../hooks/use-is-active";
import { Item } from "../item";
import { Section } from "../section";

import type { FC } from "react";

interface NavPlannerOptionsProps {
  onNavigate?: () => void;
}

export const NavPlannerOptions: FC<NavPlannerOptionsProps> = ({ onNavigate }) => {
  const isActive = useIsActive();

  const filters = makeDefaultFilters().toString();

  return (
    <Section title="Planner">
      <>
        <Item
          title="Calendar"
          icon={<Calendar />}
          onClick={{ type: "href", value: `/calendars/schedule?${filters}` }}
          onNavigate={onNavigate}
          active={isActive("/calendars")}
        />
        <Item
          title="Timeline"
          icon={<BlurLinearOutlined />}
          onClick={{ type: "href", value: `/timeline/start_date?${filters}` }}
          onNavigate={onNavigate}
          active={isActive("/timeline", true)}
        />
      </>
    </Section>
  );
};
